import { Box, Grid } from '@mui/material';
import Header from '../../../../../components/v2/Header';
import { HeadingFont, HeadingLevel, HeadingWeight } from '../../../../../components/v2/Heading/index.types';
import {
  Badge,
  badgeSize,
  badgeStyle,
  badgeType,
  colors,
  iconBtnPosition,
  IconButton,
} from '../../../../../packages';
import Typography from '../../../../../components/v2/Typography';
import { typography } from '../../../../../components/v2/Typography/index.constant';
import BoxFrame from '../../../../../components/v2/BoxFrame';
import { useSelector } from 'react-redux';
import { selectTreatmentPlans } from '../../../../../redux/modules/profile/selectors';
import { ProfileInfo } from '../../../../../packages/ui/templates/profile-info';
import React from 'react';
import dayjs from '../../../../../utils/dayjs';

export const TreatmentPlansList = ({ onViewAll }) => {
  const treatmentPlans = useSelector(selectTreatmentPlans);
  const total = treatmentPlans.length;
  return (
    <BoxFrame>
      <Grid container>
        <Grid item xs={12} md={9}>
          <Box py={2.5} px={3}>
            <Header
              label="Treatment Plans"
              fontFamily={HeadingFont.PRIMARY}
              fontVariant={HeadingLevel.SUB}
              fontWeight={HeadingWeight.SEMI_BOLD}
              badge={
                total > 0 && (
                  <Badge variant={badgeType.OUTLINED} style={badgeStyle.INACTIVE} size={badgeSize.XSMALL}>
                    {total} total
                  </Badge>
                )
              }
            />
          </Box>
        </Grid>
        {onViewAll && (
          <Grid item xs={12} md={3} display="flex" justifyContent="flex-end" alignItems="center">
            <Box sx={{ '& button': { gap: 1 } }} pr={2}>
              <IconButton icon="arrow-right" iconPosition={iconBtnPosition.RIGHT} onClick={onViewAll}>
                <Typography {...typography.body.s.bold}>View all</Typography>
              </IconButton>
            </Box>
          </Grid>
        )}
        {treatmentPlans.map((item, index) => {
          const createdToday = dayjs(item.createdAt).isToday();
          const updatedToday = dayjs(item.lastModified).isToday();
          const created = createdToday
            ? `Today, ${dayjs(item.createdAt).format('h:mm a')}`
            : dayjs(item.createdAt).format('M/D/YY, h:mm a');
          const updated = updatedToday
            ? `Today, ${dayjs(item.lastModified).format('h:mm a')}`
            : dayjs(item.lastModified).format('M/D/YY, h:mm a');
          const isExpired = dayjs(item.expiryDate).isBefore(dayjs());
          const expiryDiff = Math.abs(dayjs(item.expiryDate).diff(dayjs(), 'day'));
          return (
            <Grid
              item
              container
              key={index}
              sx={{
                borderTop: `1px solid ${colors.neutral100}`,
                cursor: 'pointer',
              }}
              onClick={onViewAll}
            >
              <Grid item xs={12} md={6}>
                <Box display="flex" gap={2} py={2.5} px={3}>
                  <Typography {...typography.body.m.medium} style={{ maxWidth: '70%' }}>
                    {item.name}
                  </Typography>
                  <Box>
                    <Badge
                      variant={badgeType.OUTLINED}
                      style={isExpired ? badgeStyle.CRITICAL : badgeStyle.PROVIDER}
                      size={badgeSize.SMALL}
                    >
                      {isExpired ? `${expiryDiff}d past due` : `${expiryDiff}d to go`}
                    </Badge>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                gap="40px"
                px="24px"
              >
                <ProfileInfo
                  type="provider"
                  photo={item?.providerDisplayPicture}
                  role={item?.providerRole}
                  fullName={item?.providerName}
                />
                <Box>
                  <Typography {...typography.body.s.semibold}>Created</Typography>
                  <Typography {...typography.body.s.medium}>{created}</Typography>
                </Box>
                <Box>
                  <Typography {...typography.body.s.semibold}>Updated</Typography>
                  <Typography {...typography.body.s.medium}>{updated}</Typography>
                </Box>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </BoxFrame>
  );
};
